import {Box, Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

export const ViewBalanceTemplate = () => (
  <Grid
    container
    size={12}
    pt={'10px'}
    display={'flex'}
    alignItems={'center'}
    justifyContent={'space-between'}>
    <Grid
      size={'grow'}
      display={'flex'}
      alignItems={'center'}
      sx={{
        zIndex: 2,
      }}>
      <Box
        sx={{
          borderRadius: '0.75rem',
          background: 'common.["ai-card-bg"]',
          width: '100%',
          height: '2.50rem',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
          flexDirection: 'column',
        }}>
        <Skeleton variant="text" width="30%" height="1.30rem" />
        <Skeleton variant="text" width="50%" height="1.30rem" />
        <Skeleton variant="text" width="50%" height="1.30rem" />
      </Box>
    </Grid>

    <Grid size={'auto'}>
      <Skeleton
        variant="rectangular"
        width="93px"
        height="33px"
        sx={{borderRadius: '0.50rem'}}
      />
    </Grid>
  </Grid>
);
